import { persianLanguage } from "../../../constants/persianTerms";

export const LoadingFallback = () => (
  <div style={{ 
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    zIndex: 9999
  }}>
    <div style={{ textAlign: 'center' }}>
      <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
        <span className="visually-hidden">
            {persianLanguage.phrase.general.IS_LOADING} ...
        </span>
      </div>
      {/* <p style={{ marginTop: '10px' }}>Loading form...</p> */}
    </div>
  </div>
);